/**
 * Bridges the "accept a combined team+workspace invite" action (which hard-
 * reloads the app to rehydrate the user's team context) to the post-accept
 * onboarding toast in `userst.ts`.
 *
 * The accepting code stashes the granted workspaceId here just before the
 * reload; afterwards `userst.ts` reads + clears it to enrich the
 * "You've joined {team}" toast with the workspace name and a "View workspace"
 * action. `sessionStorage` is used because it survives a reload within the same
 * tab but doesn't leak into unrelated future sessions.
 */
const KEY = "briefly:joinedWorkspaceViaInvite";

/** Stash the workspaceId granted by an accepted combined invite. */
export function markJoinedWorkspaceViaInvite(workspaceId: string): void {
  try {
    sessionStorage.setItem(KEY, workspaceId);
  } catch {
    // Private mode / storage disabled — the toast simply won't be enriched.
  }
}

/** Read and clear the stashed workspaceId (one-shot). */
export function takeJoinedWorkspaceViaInvite(): string | null {
  try {
    const id = sessionStorage.getItem(KEY);
    if (id) sessionStorage.removeItem(KEY);
    return id;
  } catch {
    return null;
  }
}
